import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export interface NotificationNavigation {
  route_name: string;
  params?: Record<string, any>;
}

interface RouteConfig {
  path: string[];
  queryParams?: Record<string, any>;
}

@Injectable({ providedIn: 'root' })
export class NotificationNavigationService {

  constructor(private router: Router) { }

  navigate(navigation: NotificationNavigation): void {
    if (!navigation?.route_name) return;

    const route = ROUTE_MAP[navigation.route_name];
    if (!route) {
      console.warn('Unknown route_name:', navigation.route_name);
      return;
    }

    this.router.navigate(route.path, {
      queryParams: route.queryParams || {}, 
      state: {
        __fromNotification: true,
        ...(navigation.params || {})
      }
    });
  }
}

/** CENTRAL ROUTE MAP */
const ROUTE_MAP: Record<string, RouteConfig> = {

  // Relationships
  relationship_individual_list: {
    path: ['/relationship/view/individuals']
  },
  relationship_business_list: {
    path: ['/relationship/view/business']
  },
  relationship_corporate_list: {
    path: ['/relationship/view/corporate']
  },
   relationship_deleted_list: {
    path: ['/relationship/view/deleted']
  },

  // Shared documents → SAME component, tab driven
  relationship_shared_with_me_individual_list: {
    path: ['/relationship/view/individuals'],
    queryParams: { tab: 'sharedWithMe' }
  },
  relationship_shared_with_me_business_list: {
    path: ['/relationship/view/business'],
    queryParams: { tab: 'sharedWithMe' }
  },
  relationship_shared_with_me_corporate_list: {
    path: ['/relationship/view/corporate'],
    queryParams: { tab: 'sharedWithMe' }
  },
 

  // Documents
  document_client_list: {
    path: ['/documents/view/client']
  },
  document_matter_list: {
    path: ['/documents/view/matter']
  },
  document_firm_list: {
    path: ['/documents/view/firm']
  },
  document_deleted_list: {
    path: ['/documents/view/delete']
  },

  // Meetings
  meeting_list: {
    path: ['/meetings/view']
  },
  meeting_detail: {
    // Navigate to the calendar listing view; ViewCalenderComponent will
    // read event_id from router state and auto-open the inline popup.
    path: ['/meetings/view']
  },
  appointment_list: {
    path: ['/appointments']
  },
  
  // chat 
  message_client_inbox: { path: ['/messages/clients'] },
  message_team_inbox: { path: ['/messages/teams'] } 
};